/**
 * Marketing-domain portfolio host (EPD-10104).
 *
 * Portfolios are served at `https://<PORTFOLIO_HOST>/portfolio/<slug>`
 * (www.aspire.io, EPD-12500) by the web worker, while the page's scripts,
 * styles, images and API calls stay on the app origin (creators.aspireiq.com).
 * The worker marks the shell it serves on that host with a
 * `<meta name="aspire-app-origin">` tag holding the app origin; the app reads
 * it to know it is running on the portfolio host and where its resources live.
 * On every other host the tag is absent.
 */
export const APP_ORIGIN_META_NAME = "aspire-app-origin";
